import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Spin, Tabs, TabsProps } from "antd";
import { useState } from "react";
import ClientCompany from "../Tabs/ClientCompany";
import ClientIndividual from "../Tabs/ClientIndividual";
import { SelectedClientType } from "../../../ducks/types";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  selectedClient: SelectedClientType | null;
  newClientPopUp: boolean;
}

export default function AddClientPopUp(props: PropsType) {
  const { onClose, selectedClient, newClientPopUp } = props;
  const [loading, setLoading] = useState(false);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const tabsItems: TabsProps["items"] = [
    {
      key: "company",
      label: "Company",
      disabled: selectedClient?.type === "individual" && !newClientPopUp,
      children: (
        <ClientCompany
          setLoading={setLoading}
          companyId={companyId}
          onClose={onClose}
          data={selectedClient}
          newClientPopUp={newClientPopUp}
        />
      ),
    },
    {
      key: "individual",
      label: "Individual",
      disabled: selectedClient?.type === "company" && !newClientPopUp,
      children: (
        <ClientIndividual
          setLoading={setLoading}
          companyId={companyId}
          onClose={onClose}
          data={selectedClient}
          newClientPopUp={newClientPopUp}
        />
      ),
    },
  ];

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <h2 style={{ marginBottom: "4px" }}>
        {selectedClient?.label && !newClientPopUp
          ? "Edit client"
          : "Add new client"}{" "}
      </h2>
      <p style={{ marginBottom: "20px" }}>
        Specify the property owner’s details below.
      </p>

      <h5
        style={{
          marginBottom: "8px",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 500,
        }}
      >
        Type
      </h5>

      {selectedClient?.label && !newClientPopUp ? (
        <>
          {
            tabsItems?.filter((item) => item.key === selectedClient?.type)?.[0]
              ?.children
          }
        </>
      ) : (
        <Tabs
          defaultActiveKey="1"
          items={tabsItems}
          className="propertiesTabs"
        />
      )}
    </Spin>
  );
}
